export const DEFAULT_STORY_TIME = 10000
export const PRE_VIDEO_START_DURATION = 3000
export const AVERAGE_TRAILER_DURATION = 120000
